import FileUploads from "./FileUploads.presenter";
export default FileUploads;
